<mat-card appearance="outlined">
  <mat-card-content>
    <span class="page-title">Search Results</span>
    <p>Showing results for: {{ routeParams?.keyword }}</p>
    @if (!loader.state.value["search-results"]) {
      <p>Showing {{ startIndex + 1 }} - {{ endIndex }} of {{ totalCount }}</p>
    }
    @if (searchResults.length > 0) {
      <mat-list>
        @for (result of searchResults; track result) {
          <mat-list-item>
            <a
              [routerLink]="searchService.getRouterLink(result)"
              matListItemTitle
              class="title"
              >{{ result?.name }}</a
            >
            <span matListItemLine class="sub-title">
              @for (key of Object.keys(result?.parents); track key) {
                {{ result?.parents[key]?.name }}
                @if (
                  key !==
                  Object.keys(result?.parents)[
                    Object.keys(result?.parents).length - 1
                  ]
                ) {
                  <span> | </span>
                }
              }
            </span>
          </mat-list-item>
        }
      </mat-list>
    } @else if (!($loading | async)) {
      <app-alert
        [config]="{
          title: 'Search results for this page are not available.',
          subtitle: 'Please check back later for updated search results.',
          type: 'info',
        }"
      />
    }
  </mat-card-content>
  <mat-card-actions align="start" class="sr-footer">
    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      (page)="handlePageChange($event)"
      [disabled]="$loading | async"
      [showFirstLastButtons]="true"
      aria-label="Select page"
    >
    </mat-paginator>
  </mat-card-actions>
</mat-card>
